<script setup lang="ts">
import { onBeforeMount, ref } from "vue"
import router from "@/apps/recruiter/router/router"
import tokenService from "@/common/services/TokenService"
import userRepository, { type ILoginForm } from "@/apps/recruiter/repositories/UserRepository"
import logo from "@/common/assets/study-buddy-logo.svg"
import { useUser } from "@/common/store"
import route from "@/apps/recruiter/router/route"

const form = ref<ILoginForm>({})
const userStore = useUser()

onBeforeMount(async () => {
    if (tokenService.jwt.has()) {
        await router.replace({ name: route.root.name })
    }
})

async function login() {
    form.value.loading = true
    form.value.invalidCredentials = false
    userStore.setUser({})

    try {
        const data = await userRepository.login({
            email: form.value.email,
            password: form.value.password
        })

        tokenService.setTokens(data)
        await router.replace({ name: route.root.name })
    } catch (e) {
        form.value.invalidCredentials = true
        tokenService.removeTokens()
    } finally {
        form.value.loading = false
    }
}
</script>

<template>
    <q-layout view="hHh lpR fFf" class="bg-dark-page column justify-center items-center">
        <q-page-container>
            <q-card class="login">
                <q-card-section class="column items-center">
                    <img :src="logo" alt="logo" class="logo" />
                    <div class="column items-center q-gutter-y-md buttons-wrapper full-width">
                        <div class="text-h6 text-white uppercase q-mb-md">Вход</div>
                        <q-input
                            dense
                            outlined
                            class="full-width"
                            v-model="form.email"
                            clearable
                            type="email"
                            label="Email"
                            :error="form.invalidCredentials"
                            error-message="Неверный email или пароль"
                        />
                        <q-input
                            dense
                            outlined
                            class="full-width"
                            v-model="form.password"
                            clearable
                            type="password"
                            label="Пароль"
                        />
                        <q-btn
                            color="primary"
                            label="Войти"
                            :loading="form.loading"
                            @click="login"
                            class="full-width"
                            size="lg"
                            :disable="!form.email || !form.password || form.loading"
                        />
                    </div>
                </q-card-section>
            </q-card>
        </q-page-container>
    </q-layout>
</template>

<style scoped>
.logo {
    height: 70px;
    margin-bottom: 68px;
}

.buttons-wrapper {
    margin-top: auto;
}

.login {
    background: var(--q-dark);
    padding: 80px 60px;
    min-width: 560px;
    min-height: 520px;

    .q-field__bottom {
        padding: 4px;
        text-align: center;
    }
}
</style>
